import { Link } from 'react-router-dom'

interface AgentDetailHeaderProps {
  agentName: string
  editing: boolean
  saving: boolean
  showDeleteConfirm: boolean
  editName: string
  onEditNameChange: (value: string) => void
  onEdit: () => void
  onSave: () => void
  onCancel: () => void
  onDelete: () => void
  onDeleteConfirm: () => void
  onDeleteCancel: () => void
}

function AgentDetailHeader({
  agentName,
  editing,
  saving,
  showDeleteConfirm,
  editName,
  onEditNameChange,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  onDeleteConfirm,
  onDeleteCancel,
}: AgentDetailHeaderProps) {
  return (
    <div className="agent-detail-header">
      <div className="agent-detail-header-left">
        <Link to="/agents" data-testid="agent-detail-back" className="agent-detail-back">&larr; Back to Agents</Link>
        {editing ? (
          <input
            data-testid="agent-detail-name-input"
            className="agent-detail-name-input"
            value={editName}
            onChange={(e) => onEditNameChange(e.target.value)}
          />
        ) : (
          <h1 data-testid="agent-detail-name" className="agent-detail-title">{agentName}</h1>
        )}
      </div>
      <div className="agent-detail-header-actions">
        {editing ? (
          <>
            <button data-testid="agent-detail-save" className="agent-detail-save-btn" onClick={onSave} disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button data-testid="agent-detail-cancel" className="agent-detail-cancel-btn" onClick={onCancel}>
              Cancel
            </button>
          </>
        ) : (
          <>
            <button data-testid="agent-detail-edit" className="agent-detail-edit-btn" onClick={onEdit}>
              Edit
            </button>
            {showDeleteConfirm ? (
              <div data-testid="agent-detail-delete-confirm" className="delete-confirm">
                <span className="delete-confirm-text">Delete?</span>
                <button data-testid="agent-detail-confirm-delete" className="delete-confirm-yes" onClick={onDeleteConfirm}>Yes</button>
                <button data-testid="agent-detail-cancel-delete" className="delete-confirm-no" onClick={onDeleteCancel}>No</button>
              </div>
            ) : (
              <button data-testid="agent-detail-delete" className="agent-detail-delete-btn" onClick={onDelete}>
                Delete
              </button>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default AgentDetailHeader
